import * as React from "react";
import {Wrong} from "./Wrong";

export function Late() {
    return (<Wrong text={`Das war leider zu spät. Lerne noch einmal von der Karte und gib die 
    Lösung beim nächsten Mal schneller ein.`}/>)
}
